export function isPasswordValid(value: string): boolean {
  // NOTE: 少し難しい正規表現が使用されていたので、処理内容をコメントしておきます

  // ^ 行の先頭にマッチ

  // (?= ) 肯定的先読み
  // https://developer.mozilla.org/ja/docs/Web/JavaScript/Guide/Regular_expressions/Assertions#%E3%81%9D%E3%81%AE%E4%BB%96%E3%81%AE%E3%82%A2%E3%82%B5%E3%83%BC%E3%82%B7%E3%83%A7%E3%83%B3

  // . 改行以外の任意の1文字にマッチ

  // *? 0~無限大までの数量にマッチするが、見つかったら探索をやめる(非貪欲)
  // https://developer.mozilla.org/ja/docs/Web/JavaScript/Guide/Regular_expressions/Quantifiers#%E7%A8%AE%E9%A1%9E

  // [a-zA-Z] aからzとAからZまでの1文字にマッチ

  // (?=.*?[a-z]) aからzまでの1文字(の直前の位置)が見つかるまでまで探索し、マッチした時点で探索をやめる
  // (?=.*?\d) 数字1文字(の直前の位置)が見つかるまで探索し、マッチした時点で探索をやめる
  // これらは少なくとも1文字の英小文字と数字が含まれることを表現している
  // 修正前は`(?=.*?[!-\/:-@[-`{-~])`という肯定先読みが使われていましたが、これはASCIIテーブル上の英数字を避けて記号1文字を先読みする処理となっていました

  // [!-~] !から~までの1文字にマッチ
  // !は半角英数記号の中でASCIIテーブル上で最初に出現する。~は最後に出現する。間にすべての英数字と記号が含まれる
  // https://www.rapidtables.com/code/text/ascii-table.html

  // {8,30} 8文字以上30文字以内の数量にマッチ

  // [!-~]{8,30} 半角英数記号8~30文字にマッチする(が、上記の先読みの条件にもマッチする必要がある)

  // $ 行の最後にマッチ

  // 参考: https://qiita.com/momotaro98/items/460c6cac14473765ec14

  return /^(?=.*?[a-zA-Z])(?=.*?\d)[!-~]{8,30}$/.test(value)
}
